import { render, staticRenderFns } from "./KusContentPage.vue?vue&type=template&id=40ec0b34"
import script from "./KusContentPage.vue?vue&type=script&lang=js"
export * from "./KusContentPage.vue?vue&type=script&lang=js"
import style0 from "./KusContentPage.vue?vue&type=style&index=0&id=40ec0b34&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports